import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "error404 content" }
const _hoisted_2 = { class: "error404__wrapper" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "error404__title" }, " 404 ", -1)
const _hoisted_4 = { class: "error404__text" }

import Button from '@/components/ui/Button'

export default /*#__PURE__*/_defineComponent({
  __name: 'Error404',
  setup(__props) {

// Components

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createTextVNode(_toDisplayString(_ctx.$t('error404')), 1)
        ])
      ]),
      _createVNode(_unref(Button), {
        theme: "huge",
        type: "router-link",
        to: {name: 'Main'}
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.backToMain')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})